<template>
    <div class="add-ag-component component padding">
        <div class="add-ag-main border">
            <p class="title padding weight">AG地址</p>
            <div class="form-box flex padding">
                <div class="input-form">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="App" prop="app" :rules="rules.app">
                            <el-input class="long" size="small" v-model.number="form.app"></el-input>
                        </el-form-item>
                        <el-form-item label="Group" prop="group" :rules="rules.group">
                            <el-input class="long" size="small" v-model.number="form.group"></el-input>
                        </el-form-item>
                        <el-form-item label="Level" prop="level" :rules="rules.level">
                            <el-input class="long" size="small" v-model.number="form.level"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import rules from '../../api/rule.js'

export default {
    name: "add-ag-component",
    props: ["form"],
    model: {
        prop: "form",
        event: "update"
    },
    data() {
        return {
            rules
        };
    },
    watch: {
        form(value) {
            this.$emit("update", value);
        }
    }
};
</script>

<style lang="scss" scoped>
.add-ag-component {
    width: 50%;
    .add-ag-main {
        height: 250px;
        overflow-y: auto;
    }
    .form-box {
        align-items: flex-start;
    }
    .add-button {
        justify-content: center;
        width: 120px;
        height: 120px;
        border-radius: 8px;
        font-size: 32px;
        color: #ddd;
        cursor: pointer;
    }
    .long {
        width: 280px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/add/ag.vue